import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "section-text" }, "Información PEP", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "pep-text" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "section-text" }, "*PEP"),
  /*#__PURE__*/_createTextVNode(" es la Persona Expuesta Políticamente, iIgualmente se catalogan como PEP las personas que tengan una sociedad conyugal, de hecho, o derecho con las personas expuestas políticamente nacionales o extranjeras, así como a sus familiares hasta el segundo grado de consanguinidad, segundo de afinidad y primero civil. ")
], -1)
const _hoisted_3 = { class: "highlightedTextPep" }
const _hoisted_4 = { class: "highlightedTextPep" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "pep-text" }, " Incluir la siguiente información, nombre y número de identificación: ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "pep-text" }, [
  /*#__PURE__*/_createElementVNode("ol", null, [
    /*#__PURE__*/_createElementVNode("li", null, " Los cónyuges o compañeros permanentes del PEP "),
    /*#__PURE__*/_createElementVNode("li", null, " Los familiares de las PEP, hasta el segundo grado de consanguinidad, segundo de afinidad y primero civil. "),
    /*#__PURE__*/_createElementVNode("li", null, " Los asociados de un PEP, cuando el PEP sea socio de, o esté asociado a, una persona jurídica y, además, sea propietario directa o indirectamente de una participación superior al 5% de la persona jurídica, o ejerza el control de la persona jurídica, en los términos del artículo 261 del Código de Comercio. ")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px"} }, null, -1)
const _hoisted_8 = { style: {"height":"40px"} }
const _hoisted_9 = { style: {"height":"40px"} }
const _hoisted_10 = { style: {"height":"40px"} }
const _hoisted_11 = { style: {"height":"40px"} }
const _hoisted_12 = { style: {"height":"40px"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"42px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "dinamic-form",
    class: "pep greenItem"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_3, [
                _createElementVNode("b", null, [
                  _createTextVNode("En caso de que las filas no sean suficientes, agrega más filas en \" "),
                  _createVNode(_component_el_button, {
                    circle: "",
                    class: "dinamic-form-button",
                    size: "mini",
                    type: "success ",
                    icon: "el-icon-plus"
                  }),
                  _createTextVNode(" \" ")
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("b", null, [
                  _createTextVNode("En caso de requerir eliminar alguna fila, da clic en \" "),
                  _createVNode(_component_el_button, {
                    circle: "",
                    class: "dinamic-form-button",
                    size: "mini",
                    type: "success ",
                    icon: "el-icon-minus"
                  }),
                  _createTextVNode(" \" ")
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 22 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                height: "400",
                data: _ctx.objetoPep.campos,
                span: 24
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, { width: "40%" }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, [
                        _createElementVNode("b", null, _toDisplayString(scope.$index + 1), 1)
                      ]),
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    class: "section-text-color",
                    label: "Nombre de PEP"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.Nombre,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.Nombre) = $event),
                        class: _normalizeClass([_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].Nombre.length ? 'border-invalid' : 'border-valid'])
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
                        [_vShow, !_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].Nombre.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].Nombre, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { label: "Tipo ID" }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_select, {
                        modelValue: scope.row.TipoId,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.TipoId) = $event),
                        placeholder: "Seleccionar",
                        class: _normalizeClass([_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].TipoId.length ? 'border-invalid' : 'border-valid'])
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDeIdentificacion && _ctx.parametricas.tipoDeIdentificacion
                .filter(t => t.valor !== 'NIT' && t.valor !== 'TI'), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.codigo,
                              label: item.valor,
                              value: item.valor
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
                        [_vShow, !_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].TipoId.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].TipoId, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { label: "N° de identificación" }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.NumeroIdentificacion,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.NumeroIdentificacion) = $event),
                        class: _normalizeClass([_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].NumeroIdentificacion.length ? 'border-invalid' : 'border-valid'])
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
                        [_vShow, !_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].NumeroIdentificacion.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].NumeroIdentificacion, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { label: "Tipo de vínculo" }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_input, {
                        type: "text",
                        modelValue: scope.row.TipoVinculo,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.TipoVinculo) = $event),
                        class: _normalizeClass([_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].TipoVinculo.length ? 'border-invalid' : 'border-valid'])
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
                        [_vShow, !_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].TipoVinculo.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].TipoVinculo, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { label: "Tipo de PEP" }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_select, {
                        modelValue: scope.row.TipoPep,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.TipoPep) = $event),
                        placeholder: "Seleccionar",
                        class: _normalizeClass([_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].TipoPep.length ? 'border-invalid' : 'border-valid'])
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parametricas.tipoDePep, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.codigo,
                              label: item.valor,
                              value: item.valor
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "class"]),
                      _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [
                        [_vShow, !_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].TipoPep.length]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionPep.campos.$each.$response.$errors[scope.$index].TipoPep, (error) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: error,
                          class: "section-error-message"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(error.$message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { width: "50" }, {
                    default: _withCtx((scope) => [
                      (scope.$index > 0)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            circle: "",
                            class: "dinamic-form-button",
                            size: "small",
                            type: "success",
                            icon: "el-icon-minus",
                            onClick: ($event: any) => (_ctx.EliminarFila(scope.$index))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                circle: "",
                class: "dinamic-form-button",
                size: "small",
                type: "success",
                icon: "el-icon-plus",
                onClick: _ctx.AgregarFila
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}